<template>
  <div id="avatar" :style="{width: (size + 'px'), height: (size + 'px'), 'backgroundColor': userColor}">
    <div class="initials" :style="{'line-height': (size + 'px'), 'font-size': fontSize}">{{ initials }}</div> 
  </div>
</template>

<script>

  export default {
    props: {
      user: {
        required: true
      },
      size: {
        required: true,
        type: Number
      }
    },
    computed: {
      initials () {
        return this.user && this.user.firstName && this.user.lastName ? this.user.firstName.charAt(0) + this.user.lastName.charAt(0) : 'UK';
      },
      fontSize () {
        if      (this.size > 50) return '24px';
        else if (this.size > 32) return '18px';
        else if (this.size > 26) return '14px';
        else if (this.size > 18) return '12px';
      },
      userColor () {
        return this.user && this.user.color ? 'rgba(' + this.user.color.r + ', ' + this.user.color.g + ', ' + this.user.color.b + ', 1)' : 'rgba(0, 0, 0, .54)';
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #avatar {
    position: relative;
    border-radius: 50%;
    user-select: none;

    .initials {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      @include fontPrimary400();
      color: $white;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Avatar.vue